import { DateTime } from 'luxon';

// We're MDT now, so -0600
export const saleConfig = {
  earlyAccess       : DateTime.fromISO('2025-06-19T00:01:00-06:00'), // Early Access
  saleStart         : DateTime.fromISO('2025-06-23T00:01:00-06:00'), // General
  lastChance        : null, // Last Chance at General
  surpriseExtension : null, // Surprise extension starts
  lastDay           : DateTime.fromISO('2025-07-08T00:00:00-06:00'), // Last day, hurry
  saleEnd           : DateTime.fromISO('2025-07-08T23:59:59-06:00'), // End
  code              : ''
};

export const saleStages = {
  EARLY_ACCESS: 'earlyAccess',
  REGULAR: 'regular',
  LAST_CHANCE: 'lastChance',
  SURPRISE_EXTENSION: 'surpriseExtension',
  LAST_DAY: 'lastDay'
}

export function calculateStage(date, config = saleConfig) {
  const { saleStart, lastChance, surpriseExtension, lastDay, saleEnd, earlyAccess } = config;

  if (date >= earlyAccess && date < (saleStart || lastChance || surpriseExtension || lastDay || saleEnd)) {
    return saleStages.EARLY_ACCESS;
  }

  if (date >= saleStart && date < (lastChance || surpriseExtension || lastDay || saleEnd)) {
    return saleStages.REGULAR;
  }

  if (lastChance && date >= lastChance && date < (surpriseExtension || saleEnd)) {
    return saleStages.LAST_CHANCE;
  }

  if (surpriseExtension && date >= surpriseExtension && date < (lastDay || saleEnd)) {
    return saleStages.SURPRISE_EXTENSION;
  }

  if (lastDay && date >= lastDay && date < saleEnd) {
    return saleStages.LAST_DAY;
  }

  return null;
}

export function saleEndForStage(stage, config = saleConfig) {
  const { lastChance, surpriseExtension, saleEnd } = config;
  switch (stage) {
    case saleStages.REGULAR:
      return (lastChance && lastChance.minus({minute: 1}))
        || surpriseExtension && surpriseExtension.minus({minute: 1})
        || saleEnd;
    case saleStages.LAST_CHANCE:
      return surpriseExtension && surpriseExtension.minus({minute: 1})
        || saleEnd;
    case saleStages.SURPRISE_EXTENSION:
      return saleEnd;
    case saleStages.LAST_DAY:
      return saleEnd;
  }

}
